export default __webpack_public_path__ + "static/media/default-profile2.e1816cf7.png";